(ns kyber.kyber-db.resource)

(def model
  {:ident-key
   :resource/uuid

   :refs
   {:resource/learning-objective
    {:model :learning-objective
     :cardinality :one}}

   :schema
   #:resource
   {:uuid
    {:doc "UUID of the resource"}

    :description
    {:doc "Description of the resource"}

    :download-key
    {:doc "Download key of the resource"}

    :duration
    {:doc "Duration of the resource"}

    :failed?
    {:doc "Whether the resource processing has failed"}

    :file-name
    {:doc "File name of the resource"}

    :file-size
    {:doc "File size of the resource"}

    :file-type
    {:doc "File type of the resource"}

    :m3u8
    {:doc "m3u8 of the resource"}

    :name
    {:doc "Name of the resource"}

    :page-count
    {:doc "Page count of the resource"}

    :page-dimensions
    {:doc "Page dimensions of the resource"}

    :public
    {:doc "Whether the resource is public"}

    :processing?
    {:doc "Whether the resource is processing"}

    :source-key
    {:doc "Source key of the resource"}

    :status
    {:doc "The status of the resource"}

    :url
    {:doc "url of the resource"}

    :viewer-key
    {:doc "Viewer key of the resource"}}})
